import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

export const getBidTypes = () => {
  const bidGroupVendor = BWModels.loadSchema("BidGroupVendor");

  return bidGroupVendor.__utils.bidTypes;
};
